import { render, staticRenderFns } from "./Pemakaian.vue?vue&type=template&id=3806eb51&"
import script from "./Pemakaian.vue?vue&type=script&lang=js&"
export * from "./Pemakaian.vue?vue&type=script&lang=js&"
import style0 from "./Pemakaian.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports